var React = require('react');

function UploadIconInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"#269C74","fillRule":"evenodd"},[React.createElement("path",{"d":"M10.726 6.192v9.499c0 .988.785 1.774 1.774 1.774.988 0 1.774-.785 1.774-1.774V6.163l2.82 2.82c.348.348.784.523 1.25.523.465 0 .901-.175 1.25-.524a1.756 1.756 0 000-2.5L13.75.669a1.756 1.756 0 00-2.5 0L5.407 6.511a1.756 1.756 0 000 2.5 1.755 1.755 0 002.5 0l2.82-2.819z","key":0}),React.createElement("path",{"d":"M23.023 14.768c-.988 0-1.774.784-1.774 1.773v4.797l-17.528-.001V16.54c0-.988-.785-1.773-1.774-1.773-.988 0-1.773.784-1.773 1.773v6.57c0 .989.784 1.774 1.773 1.774h21.076c.988 0 1.774-.784 1.774-1.773v-6.57c0-.989-.785-1.773-1.774-1.773z","key":1})]));
}

UploadIconInline.defaultProps = {"width":"25","height":"25"};

module.exports = UploadIconInline;

UploadIconInline.default = UploadIconInline;
